import { h } from '../dom.ts';

/** Aperçu isolé dans une iframe (les styles du back-office ne "bavent" pas sur la signature). */
export function signatureFrame(
  html: string,
  opts: { withEmail?: boolean } = {},
): HTMLIFrameElement {
  const body = opts.withEmail
    ? `<div style="font-family:Arial,sans-serif;font-size:14px;color:#222">Bonjour,<br><br>Merci pour votre message, je reviens vers vous rapidement.<br><br>Belle soirée,<br><br>${html}</div>`
    : html;
  const frame = h('iframe', {
    class: 'sigframe',
    title: 'Aperçu de la signature',
    sandbox: 'allow-same-origin',
  });
  frame.srcdoc =
    `<!doctype html><html><head><meta charset="utf-8"><style>body{margin:16px;background:#fff}</style></head><body>${body}</body></html>`;
  frame.addEventListener('load', () => {
    const doc = frame.contentDocument;
    if (!doc) return;
    frame.style.height = doc.documentElement.scrollHeight + 4 + 'px';
    // largeur réelle du contenu : c'est le conteneur (.mail, overflow-x: auto) qui défile, pas l'iframe
    frame.style.minWidth = doc.documentElement.scrollWidth + 'px';
  });
  return frame;
}
